export const PRIVILEGED_ROLES = ["admin", "CS", "sales"];